module.exports = __webpack_public_path__ + "593a3d53/img/rename-icon.de4e673d.svg";